import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getOrganizationSlug } from '../organizations/selectors';
import { getActivityCrossConnectionLogs, getActivityKEXLogs, getActivityLocationNetworkInterfacesLogs, getActivityLocationsLogs, getActivityNetworkInterfacesLogs, getActivityUsersLogs } from './data';
import { getCrossConnectionLogsPerPage, getKEXLogsPerPage, getLocationNetworkInterfacesLogsPerPage, getLocationsLogsPerPage, getNetworkInterfacesLogsPerPage, getUsersLogsPerPage } from './selectors';
import { errorReceiveActivityCrossConnectionLogs, errorReceiveActivityKEXLogs, errorReceiveActivityLocationNetworkInterfacesLogs, errorReceiveActivityLocationsLogs, errorReceiveActivityNetworkInterfacesLogs, errorReceiveActivityUsersLogs, failedReceiveActivityCrossConnectionLogs, failedReceiveActivityKEXLogs, failedReceiveActivityLocationNetworkInterfacesLogs, failedReceiveActivityLocationsLogs, failedReceiveActivityNetworkInterfacesLogs, failedReceiveActivityUsersLogs, receiveActivityCrossConnectionLogs, receiveActivityKEXLogs, receiveActivityLocationNetworkInterfacesLogs, receiveActivityLocationsLogs, receiveActivityNetworkInterfacesLogs, receiveActivityUsersLogs, receiveAllActivityCrossConnectionLogs, receiveAllActivityKEXLogs, receiveAllActivityLocationNetworkInterfacesLogs, receiveAllActivityLocationsLogs, receiveAllActivityNetworkInterfacesLogs, receiveAllActivityUsersLogs } from './slice';
export function* requestActivityCrossConnectionLogs(action) {
    const { filter, page, status } = action.payload;
    try {
        const logsPerPage = yield select(getCrossConnectionLogsPerPage);
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getActivityCrossConnectionLogs, filter, organization, logsPerPage, page, status);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveActivityCrossConnectionLogs());
        }
        else if (data) {
            if (data.length < logsPerPage) {
                yield put(receiveAllActivityCrossConnectionLogs(data));
            }
            else {
                yield put(receiveActivityCrossConnectionLogs(data));
            }
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveActivityCrossConnectionLogs());
    }
}
export function* requestActivityKEXLogs(action) {
    const { filter, page, status } = action.payload;
    try {
        const logsPerPage = yield select(getKEXLogsPerPage);
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getActivityKEXLogs, filter, organization, logsPerPage, page, status);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveActivityKEXLogs());
        }
        else if (data) {
            if (data.length < logsPerPage) {
                yield put(receiveAllActivityKEXLogs(data));
            }
            else {
                yield put(receiveActivityKEXLogs(data));
            }
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveActivityKEXLogs());
    }
}
export function* requestActivityLocationsLogs(action) {
    const { filter, page, status } = action.payload;
    try {
        const logsPerPage = yield select(getLocationsLogsPerPage);
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getActivityLocationsLogs, filter, organization, logsPerPage, page, status);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveActivityLocationsLogs());
        }
        else if (data) {
            if (data.length < logsPerPage) {
                yield put(receiveAllActivityLocationsLogs(data));
            }
            else {
                yield put(receiveActivityLocationsLogs(data));
            }
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveActivityLocationsLogs());
    }
}
export function* requestActivityNetworkInterfacesLogs(action) {
    const { page, status } = action.payload;
    try {
        const logsPerPage = yield select(getNetworkInterfacesLogsPerPage);
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getActivityNetworkInterfacesLogs, organization, logsPerPage, page, status);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveActivityNetworkInterfacesLogs());
        }
        else if (data) {
            if (data.length < logsPerPage) {
                yield put(receiveAllActivityNetworkInterfacesLogs(data));
            }
            else {
                yield put(receiveActivityNetworkInterfacesLogs(data));
            }
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveActivityNetworkInterfacesLogs());
    }
}
export function* requestActivityLocationNetworkInterfacesLogs(action) {
    const { filter, page, status } = action.payload;
    try {
        const logsPerPage = yield select(getLocationNetworkInterfacesLogsPerPage);
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getActivityLocationNetworkInterfacesLogs, filter, organization, logsPerPage, page, status);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveActivityLocationNetworkInterfacesLogs());
        }
        else if (data) {
            if (data.length < logsPerPage) {
                yield put(receiveAllActivityLocationNetworkInterfacesLogs(data));
            }
            else {
                yield put(receiveActivityLocationNetworkInterfacesLogs(data));
            }
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveActivityLocationNetworkInterfacesLogs());
    }
}
export function* requestActivityUsersLogs(action) {
    const { filter, page, status } = action.payload;
    try {
        const logsPerPage = yield select(getUsersLogsPerPage);
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getActivityUsersLogs, filter, organization, logsPerPage, page, status);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveActivityUsersLogs());
        }
        else if (data) {
            if (data.length < logsPerPage) {
                yield put(receiveAllActivityUsersLogs(data));
            }
            else {
                yield put(receiveActivityUsersLogs(data));
            }
        }
        else {
            throw new Error(t('NO_DATA_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveActivityUsersLogs());
    }
}
export function* watchRequestActivityCrossConnectionLogs() {
    yield takeLatest('activityLogs/requestActivityCrossConnectionLogs', requestActivityCrossConnectionLogs);
}
export function* watchRequestActivityKEXLogs() {
    yield takeLatest('activityLogs/requestActivityKEXLogs', requestActivityKEXLogs);
}
export function* watchRequestActivityLocationNetworkInterfacesLogs() {
    yield takeLatest('activityLogs/requestActivityLocationNetworkInterfacesLogs', requestActivityLocationNetworkInterfacesLogs);
}
export function* watchRequestActivityLocationsLogs() {
    yield takeLatest('activityLogs/requestActivityLocationsLogs', requestActivityLocationsLogs);
}
export function* watchRequestActivityNetworkInterfacesLogs() {
    yield takeLatest('activityLogs/requestActivityNetworkInterfacesLogs', requestActivityNetworkInterfacesLogs);
}
export function* watchRequestActivityUsersLogs() {
    yield takeLatest('activityLogs/requestActivityUsersLogs', requestActivityUsersLogs);
}
